import _ from 'lodash'
import * as Actions from './constants'

const LabelItemsReducer = (state, action) => {
  const {type, payload} = action
  let itemKey = ''
  let newKey = ''
  switch (type) {
    case Actions.INIT:
      state.labelItems = [...payload.items]

      // apply zoom logic
      const baseZoom = state.zoom // buffer for default scale
      state.zoom = 1 // revert scale to one, assumes that state.labelItems is scaled to 1
      state = LabelItemsReducer(state, {
        type: Actions.ZOOM,
        payload: {zoom: baseZoom},
      })
      return {...state}

    case Actions.ADD_ITEM_FIELD_SELECT:
      // reject has existing field select and
      // reject if field select does exist and new item type doesn't match
      let existingGroup = getExistingGroup(state.labelItems)
      if (existingGroup !== null && existingGroup !== payload.item.fieldselect.item.id) {
        return state
      }
    // Fall through
    case Actions.ADD_ITEM_TEXTBOX:
      LabelItemsReducer(state, {type: Actions.DESELECT_ALL_ITEM})
      itemKey = getKey(payload.item)
      newKey = updateKey(itemKey, state.labelItems)
      payload.item[itemKey].font_size *= state.zoom
      payload.item = {...payload.item[itemKey], key: newKey, focused: true}
      state.labelItems = [...state.labelItems, payload.item]
      return {...state}

    case Actions.ADD_ITEM_IMAGE:
      LabelItemsReducer(state, {type: Actions.DESELECT_ALL_ITEM})
      itemKey = getKey(payload.item)
      newKey = updateKey(itemKey, state.labelItems)
      payload.item = {...payload.item[itemKey], key: newKey, focused: true}
      state.labelItems = [...state.labelItems, payload.item]
      return {...state}

    case Actions.ADD_ITEM_QR_CODE:
    case Actions.ADD_ITEM_BAR_CODE:
    case Actions.ADD_ITEM_BAR_CODE_NT:
      itemKey = getKey(payload.item)
      if (keyExists(state.labelItems, ['qrcode', 'barcode', 'barcodenotext'])) {
        return state
      }
      LabelItemsReducer(state, {type: Actions.DESELECT_ALL_ITEM})
      itemKey = getKey(payload.item)
      payload.item = {...payload.item[itemKey], key: itemKey, focused: true}
      state.labelItems = [...state.labelItems, payload.item]
      return {...state}

    case Actions.ADD_ITEM_COMPANY_LOGO:
      if (keyExists(state.labelItems, 'companylogo')) {
        return state
      }
      LabelItemsReducer(state, {type: Actions.DESELECT_ALL_ITEM})
      itemKey = getKey(payload.item)
      payload.item = {...payload.item[itemKey], key: itemKey, focused: true}
      state.labelItems = [...state.labelItems, payload.item]
      return {...state}

    case Actions.ADD_ITEM_AP_LOGO:
      if (keyExists(state.labelItems, 'aplogo')) {
        return state
      }
      // remove focus
      LabelItemsReducer(state, {type: Actions.DESELECT_ALL_ITEM})
      itemKey = getKey(payload.item)
      payload.item = {...payload.item[itemKey], key: itemKey, focused: true}
      state.labelItems = [...state.labelItems, payload.item]
      return {...state}

    case Actions.REMOVE_ITEM:
      state.labelItems.splice(payload.index, 1)
      return {...state}

    case Actions.UPDATE_ITEM:
      state.labelItems = state.labelItems.map((obj, objIndex) => {
        if (objIndex === payload.index) return payload.item
        return obj
      })
      return {...state}

    case Actions.DESELECT_ALL_ITEM:
      state.labelItems = state.labelItems.map(obj => {
        if (obj.focused) {
          obj.focused = false
          return {...obj}
        }
        return obj
      })
      return {...state}

    case Actions.SELECT_ITEM:
      state.labelItems = state.labelItems.map((obj, objIndex) => {
        if (objIndex === payload.index) {
          if (!obj.focused) {
            obj.focused = true
            return {...obj}
          }
        } else if (obj.focused) {
          obj.focused = false // deselect other items
          return {...obj}
        }
        return obj
      })
      return {
        ...state, //
      }

    case Actions.ZOOM:
      if (state.zoom === payload.zoom) return state
      let labelElements = _.cloneDeep(state.labelItems).map(item => {
        item.size.width = item.size.width / state.zoom
        item.size.height = item.size.height / state.zoom
        item.position.top = item.position.top / state.zoom
        item.position.left = item.position.left / state.zoom
        if (item.font_size !== undefined) {
          item.font_size = item.font_size / state.zoom
        }
        return item
      })

      state.labelItems = labelElements.map(item => {
        item.size.width = item.size.width * payload.zoom
        item.size.height = item.size.height * payload.zoom
        item.position.top = item.position.top * payload.zoom
        item.position.left = item.position.left * payload.zoom
        if (item.font_size !== undefined) {
          item.font_size = item.font_size * payload.zoom
        }
        return {...item}
      })

      state.zoom = payload.zoom
      return {...state}

    default:
      return state
  }
}

export default LabelItemsReducer

export {Actions}

// AUX Functions

function getExistingGroup(items) {
  let matched = items
    .filter(obj => obj !== undefined)
    .filter(obj => {
      return obj.key.indexOf('fieldselect_') === 0
    })
  if (matched.length > 0) {
    return matched[0].item.id
  } else {
    return null
  }
}

function keyExists(items, keys) {
  if (typeof keys !== 'object') {
    keys = [keys]
  }
  return !!items.find(k => keys.includes(k.key))
}

function updateKey(key, items) {
  key = key.split('_')[0]
  let indexes = items
    .map(value => value.key)
    .filter(k => k.split('_')[0] === key)
    .map(k => parseInt(k.split('_')[1]))
  let newIndex = _.max([...indexes, -1]) + 1
  return `${key}_${newIndex}`
}

function getKey(item) {
  return Object.keys(item)[0]
}
